import styled from "../../__compat__/styled-components/main.entry.mjs.mjs";
import { injectSpacing } from "../../api/spacing/injectSpacing.mjs.mjs";
export const StyledContentCard = styled.div.withConfig({ displayName: "auir-611444a-StyledContentCard", componentId: "auir-611444a-axvka9" }) `
  --inset: var(${(props) => props.theme.responsive.spacing.l});

  box-sizing: border-box;
  padding: var(--inset);

  background-color: var(${(props) => props.theme.colors.background.card});

  filter: var(${(props) => props.theme.shadow.background.card});

  ${injectSpacing('margin')}
`;
//# sourceMappingURL=ContentCard.styles.mjs.mjs.map